<div
  class="[ hero ][ relative w-full min-h-full ][ flex flex-wrap justify-center gap-m ][ p-i-l p-b-m ][ corner-l ]"
  data-cy="hero-section"
>
  <div
    class="cta-form [ relative flex flex-column items-center flex-1 gap-m ][ p-m m-b-auto ][ surface elevation-5 border border-stroke-variant ][ corner-m ]"
    #cta
  >
    <dcr-logo logo="logo:banner" class="cta-logo"></dcr-logo>

    <campus-maintenance-mode
      *ngIf="isMaintenanceMode$ | async; else operationalMode"
      [statusPageUrl]="statusPageUrl"
    ></campus-maintenance-mode>

    <ng-template #operationalMode>
      <ng-container *ngIf="user$ | async as user; else notLoggedIn">
        <div class="title-medium" data-cy="logged-in-welcome-message">
          Welkom terug
          <span *ngIf="user.firstName">, {{ user.firstName }}!</span>
        </div>

        <dcr-tonal-button
          label="Naar het platform"
          leading-icon="portal:rocket"
          (click)="goToPlatform()"
          data-cy="btn-platform-link"
        ></dcr-tonal-button>
      </ng-container>

      <ng-template #notLoggedIn>
        <div class="actions" data-cy="login-links">
          <div class="actions">
            <dcr-tonal-button
              label="Ik ben een leerling"
              [routerLink]="['/login/student']"
              data-cy="btn-login-link-student"
            ></dcr-tonal-button>
          </div>
          <div class="actions">
            <dcr-tonal-button
              label="Ik ben een leerkracht"
              color="tertiary"
              [routerLink]="['/login/teacher']"
              data-cy="btn-login-link-teacher"
            ></dcr-tonal-button>
            <dcr-outline-button
              label="Ik ben een schoolbeheerder"
              [routerLink]="['/login/schooladmin']"
              data-cy="btn-login-link-admin"
            ></dcr-outline-button>
          </div>
        </div>
      </ng-template>
    </ng-template>

    <dcr-animated-kai
      #kai
      src="assets/rive/kai_state_machine.riv"
      autoplay
      class="animated-kai"
      (load)="loadedKai($event)"
      track-lookat
      react-to-click
    ></dcr-animated-kai>
  </div>

  <dcr-image
    class="hero-image [ w-full items-center justify-end flex-1 ]"
    src="assets/images/hero-bg.png"
    fit="contain"
    autofill
    position="right"
    aspect-ratio="1600/1176"
    alt="Juf met een rugzak vol methodes van die Keure"
  ></dcr-image>
</div>

<campus-about-section
  title="Wat is Kabas?"
  anchor="about"
  videoId="gU8OUbAP9P8"
  player="youtube"
  readMoreLink="https://www.diekeure.be/nl-be/educatief/lager-onderwijs/kabas"
  class="about"
>
  Kabas maakt blended learning mogelijk, het bevat al het nodige methodemateriaal om:
  <ul>
    <li>als leerkracht de leerstof te onderwijzen en de voortgang van je leerlingen te monitoren.</li>
    <li>als leerling de leerstof te ontdekken, in te oefenen en toe te passen in een nieuwe context.</li>
  </ul>
  Kortom: Kabas is je digitale toolbox, waarmee je op avontuur gaat met je leerlingen. In dit korte animatiefilmpje
  ontdek je alle voordelen van Kabas.
</campus-about-section>

<campus-about-section
  title="die Keure"
  anchor="diekeure"
  videoId="1yRf_0lYrgQ"
  player="youtube"
  readMoreLink="https://www.diekeure.be"
  class="diekeure"
>
  Als Vlaamse uitgeverij ontwikkelen we lesmethodes en digitale tools om jouw leerlingen met plezier te laten leren, in
  hun talenten te groeien en de wereld te ontdekken. Daarmee volgen we onze passie voor het onderwijs en de missie die
  we delen met elke leerkracht in het veld: elke leerling zo goed mogelijk onderwijzen en zich daardoor maximaal te
  laten ontplooien. Op ons leerplatform Kabas omarmen we dan ook enthousiast vol ambitie de vele mogelijkheden die de
  digitalisering biedt. Want onderwijs doet ertoe!
</campus-about-section>

<campus-faq-section></campus-faq-section>

<campus-contact-section
  [subjects]="subjects"
  [user]="user$ | async"
  [success]="contactSuccess$ | async"
  (submitForm)="contactFormSubmitted($event)"
></campus-contact-section>
